'use client';

import Box from '@mui/material/Box';
import {useLinkStatus} from 'next/link';
import type {ReactNode} from 'react';

export function LinkPending({children}: {children: ReactNode}) {
  const {pending} = useLinkStatus();
  return (
    <Box component="span" sx={{opacity: pending ? 0.55 : 1, transition: 'opacity 150ms ease'}}>
      {children}
    </Box>
  );
}

LinkPending.displayName = 'LinkPending';
